/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {Label} from '@primer/react';

export default function PendingLabel(): React.ReactElement {
  return <Label variant="attention">Pending</Label>;
}
